/// <amd-module name="Test/Analytics/TestAnalyticsTrendChart/Stores/TestInsightsTrendChartStore" />
import { ReportConfigurationDefinitions } from "Test/Analytics/Common/Definitions";
import * as CommonTypes from "Test/Analytics/Common/Types";
import { ConfigurationUtility } from "Test/Analytics/Common/Utils/ConfigurationUtility";
import { TestInsightsTrendChartActions } from "Test/Analytics/TestAnalyticsTrendChart/Actions/TestInsightsTrendChartActions";
import { TrendChartHelper } from "Test/Analytics/TrendChartCommon/TrendChartHelper";
import { ITrendChartData } from "Test/Analytics/TrendChartCommon/Types";
import { ChartProps } from "VSS/Features/Charts/Contracts";
import { Store } from "VSS/Reflux/Store";

export interface ITestInsightsTrendChartState {
    chartOptions?: ChartProps;
    metricOptions: { [key: number]: string };
    selectedMetricOption?: CommonTypes.Metric;
}

export class TestInsightsTrendChartStore extends Store {
    private _trendChartHelper: TrendChartHelper;
    private _state: ITestInsightsTrendChartState;
    private _confValues: CommonTypes.IReportConfiguration;
    private _reportConfigurationDef: ReportConfigurationDefinitions;
    constructor(private _actions: TestInsightsTrendChartActions) {
        super("");
        this._initialize();
    }

    public getState(): ITestInsightsTrendChartState {
        return this._state;
    }

    public dispose(): void {
        this._actions.updateConfigurationValuesAction.removeListener(this._onUpdateConfiguration);
        this._actions.updateTrendChartAction.removeListener(this._onUpdateTrendChart);
    }

    private _initialize(): void {
        this._trendChartHelper = new TrendChartHelper();
        this._actions.updateConfigurationValuesAction.addListener(this._onUpdateConfiguration);
        this._actions.updateTrendChartAction.addListener(this._onUpdateTrendChart);
        this._reportConfigurationDef = new ReportConfigurationDefinitions();

        this._state = {
            chartOptions: undefined,
            metricOptions: this._reportConfigurationDef.getTestInsightsChartMetricProps().options,
            selectedMetricOption: CommonTypes.Metric.ResultCount
        };
    }

    private _onUpdateConfiguration = (confValues: CommonTypes.IReportConfiguration) => {
        this._state.chartOptions = undefined; // This is done since after config change it will take time for data to come and component can show loading experience till then.
        this._confValues = { ...confValues };
        this.emitChanged();
    };

    private _onUpdateTrendChart = (chartData: ITrendChartData) => {
        if (this._confValues && !ConfigurationUtility.areConfValuesEqual(this._confValues, chartData.confValues)) {
            // Do not update store as the configuration has changed.
            return;
        }

        const chartOptions = this._trendChartHelper.getChartOptions(chartData, true);
        this._state.chartOptions = chartOptions;

        this.emitChanged();
    };
}
